import {useCallback, useRef} from "react";
import {Grid, IconButton, Paper, Tooltip} from "@mui/material";
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';


import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

export function TableComponent({columnsTable=null, rowsTable=null, handlingDoubleClick=null }){
    const gridTableRef = useRef();

    const onBtnExport = useCallback(() => {
        gridTableRef.current.api.exportDataAsCsv();
    }, []);

    return(
        <Paper elevation={12}>

            <Grid container>

                <Grid item container xs={12} justifyContent="flex-end">
                    <Tooltip title={"Descargar tabla"}>

                        <IconButton color="success" onClick={onBtnExport}>
                            <SimCardDownloadIcon/>
                        </IconButton>

                    </Tooltip>
                </Grid>

            </Grid>

            <div className="ag-theme-alpine" style={{ height: "60vh", width: '100%' }}>
                <AgGridReact
                    ref={gridTableRef}
                    columnDefs={columnsTable}
                    rowData={rowsTable}
                    pagination={true}
                    paginationPageSize={20}
                    onRowDoubleClicked={handlingDoubleClick}
                />
            </div>


        </Paper>
    );
}